module.exports = __webpack_public_path__ + "static/media/wash.6088fffd.gif";